export const capitalizeFirst = (str: string) =>
  `${str.charAt(0).toUpperCase()}${str.substring(1)}`;
